// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"712669a9","239":"f2f840dc","396":"31c7e990","455":"f4a60016","857":"1300b79e","977":"f1d6d31f"}[chunkId] + ".chunk.js";
};